export default __webpack_public_path__ + "static/media/Raytheon.f8f78cef.png";